var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6F58D19F-C34E-4B32-9BAD-FB92F27BEEE4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toast",
    transform: "translate(-120.000000, -586.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.000000, 574.000000)",
    id: "icon/ic-error"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D32F2F",
    cx: 10,
    cy: 10,
    r: 8.33333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4041667,6.42083333 L10,8.825 L10,8.825 L7.59583333,6.42083333 C7.27136604,6.09636604 6.74530062,6.09636604 6.42083333,6.42083333 C6.09636604,6.74530062 6.09636604,7.27136604 6.42083333,7.59583333 L8.825,10 L8.825,10 L6.42083333,12.4041667 C6.09636604,12.728634 6.09636604,13.2546994 6.42083333,13.5791667 C6.74530062,13.903634 7.27136604,13.903634 7.59583333,13.5791667 L10,11.175 L10,11.175 L12.4041667,13.5791667 C12.728634,13.903634 13.2546994,13.903634 13.5791667,13.5791667 C13.903634,13.2546994 13.903634,12.728634 13.5791667,12.4041667 L11.175,10 L11.175,10 L13.5791667,7.59583333 C13.903634,7.27136604 13.903634,6.74530062 13.5791667,6.42083333 C13.2546994,6.09636604 12.728634,6.09636604 12.4041667,6.42083333 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.58f9faefc2bf925683fdc63fb8cd12c8.svg";
export { ForwardRef as ReactComponent };